/*
 * @Author: zhangguoliang
 * @Date: 2022-05-07 15:11:05
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2023-01-31 14:49:18
 */
import axios, { AxiosError } from "axios";
import Cookies from "js-cookie";
import { message } from "ant-design-vue";
import { notNeedAuthorization } from "./authorization";

const instance = axios.create({
  // baseURL: "/home-api"
  baseURL: "http://www.xiangnongjy.com/home-api"
});
instance.interceptors.request.use((config) => {
  const { headers = {} } = config;
  const token = Cookies.get("cms_token");
  headers.PRODUCT_CODE = headers.PRODUCT_CODE || "AGENCY_ADMIN";
  headers.APPLICATION_NAME = "PORTAL";
  headers.TEMPLATE_CODE = "XIANGNONG_PORTAL";
  const requestUrl = config?.url ?? '';
  if(token&&!headers.accessToken&&notNeedAuthorization.findIndex(item=>requestUrl.includes(item))!==-1){
    headers.accessToken=token;
  }
  else if (token && !headers.Authorization) {
    headers.Authorization = `bearer ${token}`;
  }
  return config;
});

const errorMessage = {
  401: "认证失效，请重新登录",
  403: "没有访问权限",
  404: "访问的接口不存在",
  500: "网络请求错误",
  502: "服务器维护中",
  503: "服务器维护中",
  0: "未知错误，请稍后再试"
};

type ErrorCode = keyof typeof errorMessage;

export type CustomizeError = { msg: string; code: ErrorCode };

function handleError(data: CustomizeError) {
  const { msg, code } = data;
  const errorMsg = msg || errorMessage[code] || errorMessage[0];
  message.error(errorMsg);
  // if (code === 401) {
  // }
  return Promise.reject({ code, msg });
}

instance.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data?.code >= 400 || data?.status >= 400) {
      return handleError({
        code: data.code || data.status,
        msg: data.msg || data.message
      });
    }
    return data;
  },
  (error: AxiosError) => {
    const { response } = error as any;
    const { data, status, statusText } = response;
    return handleError({
      code: data?.code || status,
      msg: data?.msg || statusText
    });
  }
);

export default instance.request;
